import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Calendar, Clock, BookOpen, DollarSign } from 'lucide-react'; // Optional: install lucide-react for icons

const How = () => {
  const navigate = useNavigate();

  const steps = [
    {
      title: "Set Your Availability",
      description: "Define the days and times you are available to teach. You can sync this with your personal calendar.",
      icon: <Calendar className="w-6 h-6 text-blue-600" />,
      actionText: "Manage Slots",
      link: "/roleselection"
    },
    {
      title: "Define Your Subjects",
      description: "Update the specific subjects and grade levels you feel most comfortable teaching.",
      icon: <BookOpen className="w-6 h-6 text-green-600" />,
      actionText: "Update Subjects",
      link: "/tutoring/tutor1"
    },
    {
      title: "Set Your Rates",
      description: "Ensure your hourly rates are competitive and accurately reflect your expertise.",
      icon: <DollarSign className="w-6 h-6 text-amber-600" />,
      actionText: "Pricing Plans",
      link: "/tutoring/tutor1"
    }
  ];

  return (
    <div className="bg-gray-50 min-h-screen py-12 px-6">
      <h3 className="text-2xl font-bold mt-10 ">How to Manage Your Tutoring</h3>
       <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Welcome, Tutor! Your account is active. Use this area to configure how you connect with students and manage your sessions.
          </p>
      <div className="max-w-5xl mx-auto">
         {/*Header Section 
        {/*<div className="text-center mb-12">
          <h1 className="text-4xl font-extrabold text-gray-900 mb-4">How to Manage Your Tutoring</h1>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Welcome, Tutor! Your account is active. Use this area to configure how you connect with students and manage your sessions.
          </p>
        </div>*/}

        {/* Steps/Cards Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
          {steps.map((step, index) => (
            <div key={index} className="bg-white p-8 rounded-2xl shadow-sm border border-gray-100 flex flex-col h-full">
              <div className="mb-4 p-3 bg-gray-50 w-fit rounded-xl">
                {step.icon}
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-3">{step.title}</h3>
              <p className="text-gray-600 text-sm mb-6 flex-grow leading-relaxed">
                {step.description}
              </p>
              <button 
                onClick={() => navigate(step.link)}
                className="w-full py-2.5 px-4 bg-white border border-blue-600 text-blue-600 font-semibold rounded-lg hover:bg-blue-50 transition-all text-sm"
              >
                {step.actionText}
              </button>
            </div>
          ))}
        </div>

        {/* Instructions / FAQ Section */}
        <div className="bg-blue-900 rounded-3xl p-10 text-white shadow-xl overflow-hidden relative">
          <div className="relative z-10">
            <h2 className="text-2xl font-bold mb-6">Quick Best Practices</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              <div className="flex gap-4">
                <div className="bg-blue-800 p-2 rounded-lg h-fit text-blue-200">01</div>
                <div>
                  <h4 className="font-semibold mb-1">Keep Slots Updated</h4>
                  <p className="text-blue-100 text-sm">Students can book 24/7. Always update your availability to avoid cancellations.</p>
                </div>
              </div>
              <div className="flex gap-4">
                <div className="bg-blue-800 p-2 rounded-lg h-fit text-blue-200">02</div>
                <div>
                  <h4 className="font-semibold mb-1">Quality Over Quantity</h4>
                  <p className="text-blue-100 text-sm">A thorough profile description increases your booking rate by 40%.</p>
                </div>
              </div>
            </div>
          </div>
          {/* Decorative background circle */}
          <div className="absolute top-[-50px] right-[-50px] w-64 h-64 bg-blue-800 rounded-full opacity-50 blur-3xl"></div>
        </div>

        <div className="mt-12 text-center">
            <button 
              onClick={() => navigate('/profile')}
              className="text-gray-500 hover:text-gray-800 font-medium text-sm transition-all"
            >
              ← Back to My Profile
            </button>
        </div>
      </div>
    </div>
  );
};

export default How;